import React, { useState, useEffect }  from "react";
import DecoderAdder from "./DecoderAdder";
import CountryAuto from "./CountryAuto";
import SaveChanges from './SaveChanges';
import RegionAuto from './RegionAuto'
import { fetchUser } from "../../service/subscribers/subscribersApi";
// import {RegionList, SaveChanges} from "./../../../components/userPage";

const Profile = ({id, domain, regions, user, onDecodersChanged}) => {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [country, setCountry] = useState("cm");
    const [region, setRegion] = useState('');
    const [number, setNumber] = useState("");

    const handleEmailChange = (e) => {
      setEmail(e.target.value);
    }
    
    const handleNameChange = (e) => {
        setName(e.target.value);
    }
    const handleSurnameChange = (e) => {
        setSurname(e.target.value);
    }
    const handleNumberChange = (e) => {
        setNumber(e.target.value);
    }

    const [savedRegionId, saveRegionId] = useState(0);

    const fetchUserData = async () => {
      try {
        const data = await fetchUser(id);
        setEmail(data?.email);
        setName(data?.name);
        setSurname(data?.surname);
        setCountry(data?.country);
        setRegion(data?.region);
        setNumber(data?.phone);
      } catch (error) {
        console.error(error);
      }
    };
  
    useEffect(() => {
      regions?.forEach(el => {
        if(el?.region_name === region) saveRegionId(el?.region_id);
      })
    }, [region, regions]); 

    useEffect(() => {
        setEmail(user?.email);
        setName(user?.name);
        setSurname(user?.surname);
        setCountry(user?.country);
        setRegion(user?.region);
        setNumber(user?.phone);
    }, [user])
    return(
     
                // <div className="user-profile-body-in">
                  // <div className="user-profile-block">
                      <div className="user-profile-block-container">
                          <div className="user-profile-right-column">
                              <p className="columnize">id: {id}</p>
                              <p className="columnize">Email: <input 
                                  className="user-info-input"
                                  type="text" 
                                  value={email} 
                                  onChange={handleEmailChange}/>
                              </p>
                              <p className="columnize">First name: <input 
                                  className="user-info-input"
                                  type="text" 
                                  value={name} 
                                  onChange={handleNameChange}/>
                              </p>
                              <p className="columnize">Last name: <input 
                                  className="user-info-input"
                                  type="text" 
                                  value={surname} 
                                  onChange={handleSurnameChange}/>
                              </p>
                              <p><CountryAuto setType={setCountry} country={country}/></p>
                              <p><RegionAuto setType={saveRegionId} regions={regions} regionL={region}/></p>

                              <p className="columnize"> Phone number: <input 
                                  className="user-info-input"
                                  type="text" 
                                  value={number}  
                                  onChange={handleNumberChange}/>
                              </p>

                          </div>
                          <div className="user-profile-right-column">
                              <p>Decoders: </p>
                              <DecoderAdder id={id} onDecodersChanged={onDecodersChanged}/>
                              <SaveChanges prase={"Save changes"} dataToSend={{
                                user_id: id,
                                email: email,
                                phone: number || '',
                                name: name || '',
                                surname: surname || '',
                                country: country || '',
                                region_id: savedRegionId || 0,
                                timezone: "UTC",
                              }} domain={domain} fetchUser={fetchUserData}/>
                          </div>
                      </div>
                  // </div>
                // </div>
    )
}
export default Profile;